import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const sendLnk = createAsyncThunk('send/link',
    async (data)=>{
        
        fetch('https://idverify.emphasispay.com/api/send-link.php',{
            method:'POST',
            body:JSON.stringify(data)
        })
        .then((res)=>res.json())
        .then((result)=>{
            return result;
        })
        
    }
)


const initialState ={
    error:null,
    loading:false,
    submited:false,
    fname:'',
    lname:'',

    mname:'',
    alisname:'',
    bcountry:'',
    gender:'',
    chan_gender:'',
    chan_gender_spyf:'',
    country:'',
    state:'',
    city:'',
    pin:'',
    address:'',
    citizenship:'',


    fathername:'',
    dob:'',
    id_proof_exp:'',
    adress_prf_exp:'',
    email:'',
    phone:'',
}
const linkSlice = createSlice({
    name:'sendlink',
    initialState,
    reducers:{
        setError:(state,action)=>{
            state.error = action.payload
        },
        setSubmited:(state,action)=>{
            state.submited = action.payload;
        },
        setFname: (state,action)=>{
            state.fname = action.payload
        },
        setLname: (state,action)=>{
            state.lname = action.payload
        },

        setMname: (state,action)=>{
            state.mname = action.payload
        },
        setAlsname: (state,action)=>{
            state.alisname = action.payload
        },
        setBcountry: (state,action)=>{
            state.bcountry = action.payload
        },
        setGender: (state,action)=>{
            state.gender = action.payload
        },
        setCountry: (state,action)=>{
            state.country = action.payload
        },
        setState: (state,action)=>{
            state.state = action.payload
        },
        setCity: (state,action)=>{
            state.city = action.payload
        },
        setAddress: (state,action)=>{
            state.address = action.payload
        },
        setCitizenship: (state,action)=>{
            state.citizenship = action.payload
        },



        setFathername: (state,action)=>{
            state.fathername = action.payload
        },

        setDob: (state,action)=>{
            state.dob = action.payload
        },
        setIdproofExp: (state,action)=>{
            state.id_proof_exp = action.payload
        },
        setAddressprfExp: (state,action)=>{
            state.adress_prf_exp = action.payload
        },
        setEmail:(state,action)=>{
            state.email = action.payload
        },
        setPhone:(state,action)=>{
            state.phone = action.payload
        }
    },
    extraReducers(builder){
        builder
        .addCase(sendLnk.pending, (state,action)=>{
            state.loading = true;
        })
        .addCase(sendLnk.fulfilled, (state,action)=>{
            state.loading = false;
            state.submited = true;
        })
        .addCase(sendLnk.rejected, (state,action)=>{
            state.loading = false;
            state.error = action.payload;
        })
    }
})

export const {setSubmited,setError,setFname, setLname,setFathername,setDob, setEmail,setPhone,setAddressprfExp, 
    setIdproofExp,setCitizenship,setAlsname,setBcountry,setCity,setCountry,setGender,setMname,setState,setAddress
 } = linkSlice.actions;
export default linkSlice.reducer;